import React from 'react';

import '../../css/PrintDropdownOptions.scss';
import HtmlComponent from './HtmlComponent';

const PrintDropdownOptions = ({ options = [] }) => {
  const printOptions = options.reduce((list, option, index) => {
    if (!option || option.dataId === 'prependedSelectLabel' || option.value === 'prependedSelectLabel') {
      return list;
    }

    let html = '';
    if (typeof option === 'string') {
      html = option;
    } else if (option.viewLabel || option.label || option.text) {
      html = option.viewLabel || option.label || option.text;
    } else if (typeof option === 'object' && option.id && option.text) {
      html = option.text;
    }

    if (html === '' || html == null) {
      return list;
    }

    list.push({
      key: `${option.value || option.id || option.dataId || 'print-option'}-${index}`,
      html: typeof html === 'string' ? html : String(html)
    });
    return list;
  }, []);

  if (!printOptions.length) {
    return null;
  }

  return (
    <div className='print-dropdown-options'>
      {printOptions.map((option) => (
        <div key={option.key} className='print-dropdown-option'>
          <HtmlComponent htmlStr={option.html} />
        </div>
      ))}
    </div>
  );
};

export default PrintDropdownOptions;
